query GetAllRoles {
  roles {
    value
    label
  }
}
